// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__Guuvx","logoContainer":"Loader_logoContainer__nrN+t","logo":"Loader_logo__QDQUz","fadeInOut":"Loader_fadeInOut__VfzTL"};